import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import WeAreIED from "../../components/WeAreIED";
import HeroAboutVideo from "../../components/HeroAboutVideo";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import QualityManagementLanding from "../../components/Solution/QualityManagementLanding";
import QualitySmartSoltion from "../../components/Solution/QualitySmartSolution";
import GraphViewSection from "../../components/GraphViewSection";
import {
    AIDrivenQMIcon,
    FinancialImpactQMIcon,
    GradeVarianceQMIcon,
    IntegratedLaboratoryQmIcon,
    SeamlessERPQMIcon,
    RealTimeQMIcon,
    Component31,
    Component32,
    Component33,
    Component34,
    Component35,
    Component36,
} from "../../constant";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutline";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import TogetherSection from "../../components/Solution/TogetherChange";

const AnimatedCardCrausalData = [
    {
        icon: RealTimeQMIcon,
        title: "Real-Time Quality Monitoring",
        description:
            "Continuously monitor material quality, production parameters and process variations through centralized real-time dashboards and intelligent alerts.",
        // data: "“Continuously monitor material quality, production parameters and process variations through centralized real-time dashboards and intelligent alerts.”"
    },
    {
        icon: GradeVarianceQMIcon,
        title: " Grade & Variance Analytics",
        description:
            "Analyze grade fluctuations, quality deviations and process inconsistencies across batches, plants and laboratory evaluations",
        // data: "“Analyze grade fluctuations, quality deviations and process inconsistencies across batches, plants and laboratory evaluations”"
    },
    {
        icon: FinancialImpactQMIcon,
        title: "Financial Impact Assessment",
        description: "Evaluate the business impact of quality variations by correlating grades with pricing, recovery, yield, penalties and profitability.",
        //data: "“Evaluate the business impact of quality variations by correlating grades with pricing, recovery, yield, penalties and profitability.”"
    },
    {
        icon: IntegratedLaboratoryQmIcon,
        title: "Integrated Laboratory Management",
        description:
            "Leverage AI-powered analytics to identify quality trends, predict deviations and support proactive operational decision-making. ",
        // data: "“Leverage AI-powered analytics to identify quality trends, predict deviations and support proactive operational decision-making. ”"
    },
];

const tabsData = [
    {
        label: "About iED",
        key: "1",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Mission",
        key: "2",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Leadership",
        key: "3",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Differentiators",
        key: "4",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Technology",
        key: "5",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
];

const slidesData = [

    {
        viewData: [
            {
                imgUrl: [Component31],
            },
            {
                imgUrl: [Component32],
            },
            {
                imgUrl: [Component33],
            },
            {
                imgUrl: [Component34],
            },
            {
                imgUrl: [Component35],
            },
            {
                imgUrl: [Component36],
            }

        ],











        menuItems: [{
            title: "Grade Analytics",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "Performance Analytics ",
            Icons: PeopleOutlineOutlinedIcon,
        },
        {
            title: "SOP Repository",
            Icons: DashboardOutlinedIcon,
        },
        {
            title: "Observations",
            Icons: HomeOutlinedIcon,
        },
        {
            title: "CAPA Tracker",
            Icons: DashboardOutlinedIcon
        },
        {
            title: "Audit Management",
            Icons: PeopleOutlineOutlinedIcon,
        },
        ],
    }


];


export default function SolutionQualityManagement() {
    return (
        <>
            <QualityManagementLanding />
            <AnimatedCardCrausal
                title={"Intelligent Solutions for Quality-Driven Operations"}
                subTitle={"Explore our comprehensive quality management solutions designed to improve process consistency, optimize operational performance and enable data-driven quality decisions across process industries."}
                data={AnimatedCardCrausalData}
            />
            <QualitySmartSoltion />
            <GraphViewSection
                title={"Why Choose Us? Intelligence Built for Quality-Driven Operations."}
                subTitle={"Our solutions are purpose-built for process industries to enable real-time quality visibility, operational transparency and data-driven decision-making across production, laboratory and enterprise systems. By integrating quality analytics, process monitoring and financial impact evaluation into a unified platform, we help organizations improve consistency, reduce losses and maximize operational value."}
                data={slidesData}
            />


            <WeAreIED />
            <HeroAboutVideo tabsData={tabsData} isNetzero={true} />
            <TogetherSection title={"Driving Sustainable Change, Together"}
                subTitle={"We help organizations transform quality management through intelligent analytics, real-time operational visibility and integrated decision-support systems. From monitoring material quality and process consistency to evaluating the financial impact of quality variations, our solutions empower enterprises to optimize performance, improve reliability and drive smarter business outcomes across operations."}
            />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
